import React from 'react';
import { get, pick } from 'lodash';
import { Image } from 'semantic-ui-react';
import HHImage from './image';
// import { IMAGE_RESIZE } from '../network/api';
import { User } from './constant';

const defaultAvatar = (props, bgColor, initial) => {
  const {
    bgSize, fontSize, className, border
  } = props;

  const styles = {
    backgroundColor: bgColor,
    fontSize,
    border
  };
  if (bgSize) {
    styles.width = bgSize;
    styles.height = bgSize;
  }

  let classes = 'default_avatar';
  if (className) {
    classes = [classes, className].join(' ');
  }

  return (
    <div
      className={classes}
      style={styles}
    >
      <div className='default_avatar_caption'>
        { initial }
      </div>
    </div>
  );
};

const applyRestProps = (restProps) => pick(restProps, ['avatar']);

const Avatar = props => {
  const {
    hasDimmer, className, alt, user, ...restProps
  } = props;

  const firstName = get(user, 'basicInfo.firstName', false) || get(user, 'firstName', false);
  const lastName = get(user, 'basicInfo.lastName', false) || get(user, 'lastName', false);
  const bgColor = get(user, 'basicInfo.bgColor', false) || get(user, 'bgColor', false);
  const avatarUrl = props.avatarUrl || get(user, 'basicInfo.avatarUrl', false) || get(user, 'avatarUrl', false);

  if (avatarUrl) {
    return hasDimmer ?
      <HHImage
        src={avatarUrl}
        alt={alt || 'Avatar'}
        className={className}
        {...applyRestProps(restProps)}
      /> :
      <Image
        src={avatarUrl}
        alt={alt || 'Avatar'}
        className={className}
        {...applyRestProps(restProps)}
      />;
  } else if (bgColor && firstName && lastName) {
    const initial = [firstName.charAt(0).toUpperCase(), lastName.charAt(0).toUpperCase()].join('');

    return hasDimmer ?
      <HHImage
        imgComponent={defaultAvatar(props, bgColor, initial)}
      /> :
      defaultAvatar(props, bgColor, initial);
  }
  return hasDimmer ?
    <HHImage
      src={User.defaultNavIcon}
      alt={alt || 'Avatar'}
      className={className}
      {...applyRestProps(restProps)}
    /> :
    <Image
      src={User.defaultNavIcon}
      alt={alt || 'Avatar'}
      className={className}
      {...applyRestProps(restProps)}
    />;
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/common/avatar.js